<template>
  <div>
    <div class="page-title-block">
      <mtd-row class="page-head-block">
        <mtd-col :span="21" class="height-full">
          <span class="page-head-title">{{ $getText('operation_menu_alarm', '告警') }}</span>
        </mtd-col>
        <a href="https://km.sankuai.com/collabpage/2257670643" target="_blank">
          <mtd-button :span="3" type="text" icon="mtdicon mtdicon-question-circle-o" style="float: right">
            <span>{{ $getText('operation_alarm_btn_view_faq', '告警处理FAQ')}}</span>
          </mtd-button>
        </a>
      </mtd-row>
      <mtd-row>
        <mtd-form :model="search_params" :label-width="100">
          <mtd-row :gutter="16">
            <mtd-col :span="6">
              <mtd-form-item prop="params" style="padding-left: 0" :label="text_data.search_keyword_label + ':'">
                <mtd-input prefix-icon="mtdicon mtdicon-search" :placeholder="text_data.search_keyword_tips" style="width: 100%;"
                           v-model="search_params.keyword" clearable/>
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="6">
              <mtd-form-item prop="appealStatus" :label="text_data.search_status + ':'">
                <mtd-select style="width: 100%;" v-model="search_params.appealStatus" clearable>
                  <mtd-option :label="text_data.search_status_all" value="0"/>
                  <mtd-option :label="text_data.search_status_finished" value="1"/>
                  <mtd-option :label="text_data.search_status_unfinish" value="2"/>
                </mtd-select>
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="6">
              <mtd-form-item prop="createTime" :label="text_data.search_time + ':'">
                <mtd-date-picker type="datetimerange" :placeholder="text_data.search_time_tips" style="width: 100%" value-format="timestamp"
                                 class="search_datetime_range" v-model="search_params.createTime" clearable
                                 :options="daterange_option"/>
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="6">
              <mtd-form-item prop="params" style="padding-right: 0" :label="text_data.search_cc + ':'">
                <mtd-input :placeholder="text_data.search_cc_tips" style="width: 100%;"
                           v-model="search_params.cc" clearable />
              </mtd-form-item>
            </mtd-col>
          </mtd-row>
          <mtd-row :gutter="16">
            <mtd-col :span="6">
              <mtd-form-item :label="text_data.search_org + ':'" style="margin-bottom: 0">
                <mtd-cascader :data="org_path_list" v-model="search_params.attributionBusinessArray"
                              :formatter="org_format" clearable change-on-select style="width: 100%"
                              filterable remote :loading="org_searching" :remote-method="query_org_list"
                              :placeholder="text_data.search_tips"
                              :load-data="load_sub_org" @change="change_org_data"/>
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="2" :offset="12">
              <mtd-form-item :label-width="0" style="margin-bottom: 0">
                <mtd-button  :ghost="hasTimeout === 0" type="primary" @click="change_timeout">
                  {{ timeout_button_text }}</mtd-button>
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="4">
              <mtd-form-item style="margin-bottom: 0;padding-right: 0">
                <div style="float: right;">
                  <mtd-button type="text" style="color: #0a70f5;" @click="reset_search_params">{{ $getText('operation_alarm_search_reset', '重置') }}</mtd-button>
                  <mtd-button ghost type="primary" @click="init_table(true)">{{ $getText('operation_alarm_btn_search', '搜索') }}</mtd-button>
                </div>
              </mtd-form-item>
            </mtd-col>
          </mtd-row>
        </mtd-form>
      </mtd-row>
    </div>
    <mtd-row class="page-content-block">
      <mtd-row>
        <mtd-button type="text" style="color: #0a70f5;float: right" icon="mtdicon-avatar-add" :disabled="select_id_list.length === 0" @click="open_cc_modal">
          {{ $getText('operation_alarm_btn_add_cc', '添加抄送人') }}
        </mtd-button>
      </mtd-row>
      <mtd-row style="margin-top: 8px">
        <mtd-table :data="reminders_list" :loading="reminders_list_loading" loading-message="查询中"
                   :selection="table_selection"
                   @select="table_column_selected"
                   @select-all="table_column_selected"
                   @row-click="select_row">
          <mtd-table-column type="selection" width="34"/>
          <mtd-table-column prop="createTime" :label="text_data.column_time" width="140">
            <template slot-scope="scope">
              {{scope.row.createTime|dateTimeFormat}}
            </template>
          </mtd-table-column>
          <mtd-table-column prop="beAlertedMis" :label="text_data.column_mis" show-overflow-tooltip width="140"/>
          <mtd-table-column prop="alarmName" :label="text_data.column_alarm_name" show-overflow-tooltip width="140">
            <template slot-scope="scope">
              {{ scope.row.alarmName||scope.row.taskName }}
            </template>
          </mtd-table-column>
          <mtd-table-column prop="rowStatus" :label="text_data.column_status" width="220">
            <template slot-scope="scope">
              <mtd-tag theme="green" type="pure" style="cursor: pointer" @click.stop="show_detail(scope.row.id)" class="page-head-title-tag" v-if="scope.row.taskStatus !== 100 && scope.row.rowStatus === 1">
                {{ $getText('operation_alarm_status_only_reminder', '仅告警提醒') }}
              </mtd-tag>
              <mtd-tag theme="red" type="pure" style="cursor: pointer" @click.stop="show_detail(scope.row.id)" class="page-head-title-tag" v-if="scope.row.taskStatus !== 100 && scope.row.rowStatus === 2">
                {{ $getText('operation_alarm_status_self_feedback', '待本人反馈') }}
              </mtd-tag>
              <mtd-tag theme="red" type="pure" style="cursor: pointer" @click.stop="show_detail(scope.row.id)" class="page-head-title-tag" v-if="scope.row.taskStatus !== 100 && scope.row.rowStatus === 3">
                {{ $getText('operation_alarm_status_supersivor_confirm', '待相关方确认') }}
              </mtd-tag>
              <mtd-tag theme="red" type="pure" style="cursor: pointer" @click.stop="show_detail(scope.row.id)" class="page-head-title-tag" v-if="scope.row.taskStatus !== 100 && scope.row.rowStatus === 6">
                {{ $getText('operation_alarm_status_sec_recheck', '待信安复核') }}
              </mtd-tag>
              <mtd-tag theme="green" type="pure" style="cursor: pointer" @click.stop="show_detail(scope.row.id)" class="page-head-title-tag" v-if="scope.row.taskStatus !== 100 && scope.row.rowStatus === 9">
                {{ $getText('operation_alarm_status_finished', '已完成') }}
              </mtd-tag>
              <mtd-tag theme="green" type="pure" style="cursor: pointer" @click.stop="show_detail(scope.row.id)" class="page-head-title-tag" v-if="scope.row.taskStatus === 100">
                {{ $getText('operation_alarm_status_finished', '已完成') }}
              </mtd-tag>
            </template>
          </mtd-table-column>
          <mtd-table-column prop="cc" :label="text_data.column_cc" width="120" show-overflow-tooltip/>
          <mtd-table-column prop="attributionBusiness" :label="text_data.column_org" show-overflow-tooltip/>
          <mtd-table-column prop="content" :label="text_data.column_detail" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.beAlertedMis === login_user.mis_id">{{ is_en ? (scope.row.enContent || scope.row.content) : scope.row.content }}</span>
              <span class="alarm_info_content" v-else-if="scope.row.supervisor === login_user.mis_id">
                {{ is_en ? (scope.row.enSuperiorContent || scope.row.superiorContent || scope.row.enContent || scope.row.content) : (scope.row.superiorContent || scope.row.content) }}
              </span>
              <span class="alarm_info_content" v-else-if="is_cc_role(scope.row)">
                {{ is_en ? (scope.row.enCcContent || scope.row.ccContent || scope.row.enContent || scope.row.content) : (scope.row.ccContent || scope.row.content) }}
              </span>
              <span class="alarm_info_content" v-else>{{ is_en ? (scope.row.enContent || scope.row.content) : scope.row.content }}</span>
            </template>
          </mtd-table-column>
          <mtd-table-column :label="text_data.column_operate" width="180" fixed="right">
            <template slot-scope="scope">
              <mtd-button type="text" size="small" @click.stop="show_detail(scope.row.id)" style="color: #0a70f5">
                {{ $getText('operation_alarm_link_view_detail', '查看详情') }}
              </mtd-button>
              <mtd-button v-if="scope.row.rowStatus === 3" size="small" type="text" style="color: #0a70f5"
                          v-clipboard:copy.stop="get_urge_url(scope.row.id)"
                          v-clipboard:success.stop="onCopy"
                          v-clipboard:error.stop="onError">
                {{ $getText('operation_alarm_link_copy_link', '复制链接') }}
              </mtd-button>
            </template>
          </mtd-table-column>
        </mtd-table>
        <div style="text-align: right;margin-top: 12px;">
          <mtd-pagination size="small" :total="pagination.total" :current-page="pagination.current_page"
                          :page-size="pagination.page_size" style="display: inline-block;"
                          @change="handlePaginationChange"/>
        </div>
      </mtd-row>
    </mtd-row>
    <mtd-modal :title="text_data.add_cc_title" width="40%" v-model="cc_modal"
               @close="close_cc_modal">
      <mtd-row>
        <mtd-form ref="cc_form_ref" :label-width="120" :model="cc_form">
          <mtd-form-item :label="text_data.cc_list" prop="ccList" :rules="{required: true, message: text_data.input_mis_tips}">
            <mtd-select :filterable="true" style="width: 100%" v-model="cc_form.ccList"
                        multiple :remote="true" :remote-method="query_misid_list"
                        :loading="misid_loading" :placeholder="text_data.input_mis_tips">
              <mtd-option v-for="item in user_misid_list" :key="item.mis" :label="item.name + '/' + item.mis"
                          :value="item.mis"/>
            </mtd-select>
          </mtd-form-item>
        </mtd-form>
      </mtd-row>
      <div slot="footer" class="demo-modal-footer">
        <mtd-button @click="close_cc_modal">{{ $getText('operation_alarm_btn_cancel', '取消') }}</mtd-button>
        <mtd-button type="primary" @click="submit_cc_form()">{{ $getText('operation_alarm_btn_confirm', '确定') }}</mtd-button>
      </div>
    </mtd-modal>
  </div>
</template>

<script>

  import moment from 'moment';
  import {mapActions} from 'vuex'

  export default {
    name: "index",
    filters: {
      dateTimeFormat(dateTime) {
        if (dateTime) {
          return moment(dateTime).format('YYYY-MM-DD HH:mm:ss');
        } else {
          return "";
        }
      },
    },
    computed: {
      login_user() {
        return this.$store.getters.get_login_user;
      },
      is_en() {
        return this.$i18nClient.getCurrentLocale() === 'en';
      }
    },
    data() {
      const today = new Date();
      const start_today = new Date();
      start_today.setHours(0, 0, 0, 0);
      const shortcuts = [
        {
          text: this.$getText('operation_platform_last_day', '最近一天'),
          value() {
            return [start_today, today];
          },
        },
        {
          text: this.$getText('operation_platform_last_week', '最近一周'),
          value() {
            const oneWeek = new Date();
            oneWeek.setTime(start_today.getTime() - 3600 * 1000 * 24 * 7);
            return [oneWeek, today];
          },
        },
        {
          text: this.$getText('operation_platform_last_month', '最近一月'),
          value() {
            const oneMonth = new Date();
            oneMonth.setTime(start_today.getTime() - 3600 * 1000 * 24 * 30);
            return [oneMonth, today];
          },
        },
      ];

      return {
        reminders_list: [],
        reminders_list_loading: false,
        pagination: {
          total: 125,
          current_page: 1,
          page_size: 10,
        },
        search_params: {
          riskLevel:'',
          keyword: '',
          appealStatus: '0',
          createTime: [],
          attributionBusinessArray: [],
          attributionBusiness: '',
          cc: ''
        },
        table_loading: false,
        daterange_option: {
          shortcuts
        },
        timeout_button_text: this.$getText('operation_alarm_search_timeout', '筛选超时未反馈告警'),
        hasTimeout: 0,
        org_path_list: [
          {
            value: '美团',
            label: '美团',
            children: []
          }
        ],
        org_searching: false,
        table_selection: [],
        select_id_list: [],
        cc_modal: false,
        cc_form: {
          ccList: []
        },
        user_misid_list: [],
        misid_loading: false,
        text_data: {
          search_keyword_label: '关键字',
          search_keyword_tips: '当事人mis/告警名称',
          search_status: '告警状态',
          search_status_all: '全部',
          search_status_finished: '已完成',
          search_status_unfinish: '未完成',
          search_time: '告警时间',
          search_time_tips: '选择时间',
          search_cc: '抄送人',
          search_cc_tips: '请输入抄送人MIS',
          search_tips: '请选择',
          search_org: '归属业务',
          column_time: '告警时间',
          column_mis: '当事人账号',
          column_alarm_name: '告警名称',
          column_status: '告警状态',
          column_cc: '抄送人',
          column_org: '归属业务',
          column_detail: '风险详情',
          column_operate: '操作',
          add_cc_title: '添加抄送人',
          cc_list: '抄送人列表',
          input_mis_tips: '请输入MIS'
        }
      }
    },
    mounted: function () {
      this.text_data.search_keyword_label = this.$getText('operation_alarm_search_keyword', '关键字');
      this.text_data.search_keyword_tips = this.$getText('operation_alarm_search_keyword_tips', '当事人mis/告警名称');
      this.text_data.search_status = this.$getText('operation_alarm_search_status', '告警状态');
      this.text_data.search_status_all = this.$getText('operation_alarm_search_status_all', '全部');
      this.text_data.search_status_finished = this.$getText('operation_alarm_search_status_finished', '已完成');
      this.text_data.search_status_unfinish = this.$getText('operation_alarm_search_status_unfinish', '未完成');
      this.text_data.search_time = this.$getText('operation_alarm_search_time', '告警时间');
      this.text_data.search_time_tips = this.$getText('operation_alarm_search_time_tips', '选择时间');
      this.text_data.search_cc = this.$getText('operation_alarm_search_cc', '抄送人');
      this.text_data.search_cc_tips = this.$getText('operation_alarm_search_cc_tips', '请输入抄送人MIS');
      this.text_data.search_org = this.$getText('operation_alarm_search_org', '归属业务');
      this.text_data.column_time = this.$getText('operation_alarm_column_time', '告警时间');
      this.text_data.column_mis = this.$getText('operation_alarm_column_mis', '当事人账号');
      this.text_data.column_alarm_name = this.$getText('operation_alarm_column_alarm_name', '告警名称');
      this.text_data.column_status = this.$getText('operation_alarm_column_status', '告警状态');
      this.text_data.column_cc = this.$getText('operation_alarm_column_cc', '抄送人');
      this.text_data.column_org = this.$getText('operation_alarm_column_org', '归属业务');
      this.text_data.column_detail = this.$getText('operation_alarm_column_detail', '告警详情');
      this.text_data.column_operate = this.$getText('operation_alarm_column_operate', '操作');
      this.text_data.add_cc_title = this.$getText('operation_alarm_btn_add_cc', '添加抄送人');
      this.text_data.cc_list = this.$getText('operation_alarm_cc', '抄送人列表');
      this.text_data.input_mis_tips = this.$getText('operation_alarm_input_mis_tips', '请输入MIS');
      this.text_data.search_tips = this.$getText('operation_alarm_search_tips', '请选择');

      const params = this.$route.query;
      if (Object.keys(params).length !== 0) {
        Object.assign(this.search_params, params);
      }
      if (params.riskLevel) {
        this.search_params.riskLevel = params.riskLevel;
      }
      if (params.timeout === 'true') {
        this.hasTimeout = 1;
      } else {
        this.hasTimeout = 0;
      }
      this.init_table();
    },
    methods: {
      ...mapActions([
        'api_list_reminders_inquiries',
        'api_query_org_list',
        'api_query_sub_org',
        'api_add_reminders_cc',
        'api_query_org_misid_list',
        'api_check_task_vp'
      ]),
      async init_table(isBtnSearch) {
        if (isBtnSearch) {
          this.pagination.current_page = 1;
        }
        this.table_selection = [];
        this.select_id_list = [];
        this.reminders_list = [];
        this.reminders_list_loading = true;
        const params = Object.assign({}, this.search_params);
        params['pageNum'] = this.pagination.current_page;
        params['limit'] = this.pagination.page_size;
        if (this.hasTimeout === 1) {
          params['timeout'] = '1';
        } else {
          params['timeout'] = '0';
        }
        let response = await this.api_list_reminders_inquiries(params);
        let result = response.data;
        this.reminders_list = result.items;
        this.pagination.total = result.tn;
        this.reminders_list_loading = false;
      },
      reset_search_params() {
        this.search_params = {
          riskLevel: '',
          keyword: '',
          appealStatus: 0,
          createTime: [],
          attributionBusinessArray: [],
          attributionBusiness: '',
          cc: ''
        }
      },
      show_detail(id) {
        window.open('/#/alarm/' + id);
      },
      handlePaginationChange(current, size) {
        this.pagination.current_page = current;
        this.pagination.page_size = size;
        this.init_table();
      },
      onCopy() {
        this.$mtd.message.success(this.$getText('operation_alarm_copy_success', '复制成功'));
      },
      onError() {
        this.$mtd.message.error("复制失败");
      },
      get_urge_url(id) {
        return window.location.href + "/" + id;
      },
      is_cc_role(row) {
        return row.cc && row.cc.indexOf(this.login_user.mis_id) !== -1;
      },
      change_timeout() {
        if (this.hasTimeout === 1) {
          this.hasTimeout = 0;
        } else {
          this.hasTimeout = 1;
        }
        if (this.hasTimeout === 1) {
          this.timeout_button_text = this.$getText('operation_alarm_search_cancel_timeout', '取消筛选超时未反馈告警');
        } else {
          this.timeout_button_text = this.$getText('operation_alarm_search_timeout', '筛选超时未反馈告警');
        }
        this.init_table();
      },
      org_format(_labels, _selectedOptions, value) {
        if (value && value instanceof Array) {
          return value.join('-');
        }
        return '';
      },
      load_sub_org(item, resolve) {
        let keyword = '公司';
        setTimeout(() => {
          if (this.search_params.attributionBusinessArray && this.search_params.attributionBusinessArray.length > 0) {
            keyword = keyword + '-' + this.search_params.attributionBusinessArray.join("-");
          }
          this.api_query_sub_org({keyword: keyword}).then(res => {
            if (res.code === 0) {
              if (res.data.length > 0) {
                resolve(res.data);
              } else {
                item.isLeaf = true;
              }
            }
          })
        }, 200)
      },
      async query_org_list(keyword) {
        if (keyword) {
          this.org_searching = true;
          this.api_query_org_list({keyword}).then((res) => {
            const orgPathList = [];
            res.data.forEach(item => {
              orgPathList.push(item.orgNamePath);
            });
            this.org_path_list = this.convert_org(orgPathList);
          }).finally(() => {
            this.org_searching = false;
          });
        }
      },
      convert_org(orgPathList) {
        const treePathList = [];
        for (const s of orgPathList) {
          if (s === "") {
            continue;
          }
          let last = "";
          let fullLast = "";
          let fullValue = "";
          const list = s.split("-");
          for (const s1 of list) {
            if (s1 === "公司") {
              continue;
            }
            if (fullLast === "") {
              fullValue = s1;
            } else {
              fullValue = fullLast + "-" + s1;
            }
            const path = {
              label: s1,
              fullValue: fullValue,
              value: s1,
              fullParent: fullLast,
              parent: last,
              children: [],
              isLeaf: false,
            };
            let isExist = false;
            for (let i = 0; i < treePathList.length; i++) {
              if (treePathList[i].fullValue === path.fullValue) {
                isExist = true;
                break;
              }
            }
            if (!isExist) {
              treePathList.push(path);
            }
            last = s1;
            fullLast = fullValue;
          }
        }
        const groupMap = {};
        for (let i = 0; i < treePathList.length; i++) {
          const platform = treePathList[i];
          if (!groupMap[platform.fullParent]) {
            groupMap[platform.fullParent] = [];
          }
          groupMap[platform.fullParent].push(platform);
        }
        for (let i = 0; i < treePathList.length; i++) {
          const platform = treePathList[i];
          if (platform.children.length === 0) {
            platform.children = groupMap[platform.fullValue];
          }
        }
        const result = [];
        for (let i = 0; i < treePathList.length; i++) {
          const platform = treePathList[i];
          if (platform.parent === "") {
            result.push(platform);
          }
        }
        return result;
      },
      change_org_data(_value, selectedOptions) {
        if (selectedOptions.length === 0) {
          this.org_path_list = [
            {
              value: '美团',
              label: '美团',
              children: []
            }
          ]
        } else {
          this.search_params.attributionBusiness = this.search_params.attributionBusinessArray.join('-');
        }
      },
      table_column_selected(selection) {
        const id_list = [];
        selection.forEach(function (item) {
          id_list.push(item.id);
        });
        this.select_id_list = id_list;
      },
      select_row({row}) {
        let flag = false;
        for (let i = 0; i < this.table_selection.length; i++) {
          if (this.table_selection[i].id === row.id) {
            this.table_selection.splice(i, 1);
            flag = true;
            break;
          }
        }
        if (!flag) {
          this.table_selection.push(row);
        }
        this.table_column_selected(this.table_selection);
      },
      query_misid_list(keyword) {
        const vm = this;
        clearTimeout(vm.remote_mis_timer);
        if (keyword) {
          vm.misid_loading = true;
          vm.remote_mis_timer = setTimeout(async () => {
            const response = await vm.api_query_org_misid_list({keyword});
            vm.user_misid_list = response.data;
            vm.misid_loading = false;
          }, 500);
        }
      },
      open_cc_modal() {
        this.cc_modal = true;
      },
      close_cc_modal() {
        this.cc_modal = false;
        this.cc_form = {
          ccList: []
        }
      },
      async submit_cc_form() {
        await new Promise((resolve, reject) => {
          this.$refs.cc_form_ref.validate((valid) => {
            if (valid) {
              const params = {
                idList: this.select_id_list,
                ccList: this.cc_form.ccList
              };
              const vm = this;
              this.api_check_task_vp({misIdList: this.cc_form.ccList}).then(res => {
                if (res.code === 0 && res.data && res.data.length > 0) {
                  this.$mtd.confirm({
                    title: this.$getText('operation_alarm_include_vp_title', '涉及高职级人群提醒'),
                    message: this.$getText('operation_alarm_include_vp_tips', {'params': res.data.join(',')}),
                    width: '430px',
                    showCancelButton: true,
                    cancelButtonText: this.$getText('operation_alarm_include_vp_btn_cancel', '取消操作'),
                    okButtonText: this.$getText('operation_alarm_include_vp_btn_confirm', '确认提交'),
                    onCancel: function () {
                      reject('rejected');
                    },
                    onOk: function () {
                      vm.api_add_reminders_cc(params).then(res => {
                        if (res.code === 0) {
                          vm.$mtd.message.success(vm.$getText('operation_alarm_cc_add_success_tips', '添加抄送人成功'));
                          vm.init_table();
                          vm.close_cc_modal();
                        } else {
                          vm.$mtd.message.success(vm.$getText('operation_alarm_cc_add_failure_tips', '添加抄送人失败'));
                        }
                        resolve();
                      }).catch(() => {
                        resolve();
                      });
                    }
                  }).catch(() => {
                    resolve();
                  })
                } else {
                  vm.api_add_reminders_cc(params).then(res => {
                    if (res.code === 0) {
                      vm.$mtd.message.success(vm.$getText('operation_alarm_cc_add_success_tips', '添加抄送人成功'));
                      vm.init_table();
                      vm.close_cc_modal();
                    } else {
                      vm.$mtd.message.success(vm.$getText('operation_alarm_cc_add_failure_tips', '添加抄送人失败'));
                    }
                    resolve();
                  }).catch(() => {
                    resolve();
                  });
                }
              })
            } else {
              resolve();
            }
          });
        })
      },
    }
  }
</script>

<style>
  .mtd-table-cell {
    font-size: 12px;
  }
</style>
